import { render, staticRenderFns } from "./mall-add.vue?vue&type=template&id=c551b740&scoped=true&"
import script from "./mall-add.vue?vue&type=script&lang=js&"
export * from "./mall-add.vue?vue&type=script&lang=js&"
import style0 from "./mall-add.vue?vue&type=style&index=0&id=c551b740&prod&scoped=true&lang=css&"
import style1 from "./mall-add.vue?vue&type=style&index=1&id=c551b740&prod&lang=scss&scoped=true&"
import style2 from "./mall-add.vue?vue&type=style&index=2&id=c551b740&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c551b740",
  null
  
)

export default component.exports